export const runLiftA = "runLiftA";
export const runLiftB = "runLiftB";
export const isMoving = "isMoving";
export const changeLevelCount = "changeLevelCount";
export const upperLiftPosition = "upperLiftPosition";
export const changeHeight = "changeHeight";
export const changeWidth = "changeWidth";
export const fieldActions = "fieldActions";
